$ = require 'jquery'
Auth = require 'db/auth'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/power_ups_calendar_prefs'

module.exports = class CalendarSettingsView extends View
  viewTitleKey: 'calendar settings'

  initialize: ->
    @generating = false
    @listenTo @model,
      'change:prefs': @render
      'change:myPrefs.calendarKey': @generationComplete

  events:
    'click .js-calendar-pref-feed:not(.disabled)': 'selectFeedEnabled'
    'click .js-calendar-feed-url:not(:disabled)': 'focusInput'
    'click .js-regen-calendar-url:not(.disabled)': 'generateNewFeedURL'

  generationComplete: ->
    @generating = false
    @render()

  generateNewFeedURL: (e) ->
    Util.stop e
    @generating = true
    @model.generateCalendarKey()
    @render()

  render: ->
    prefs = @model.toJSON({ prefs: true }).prefs
    key = @model.getPref('calendarKey')
    feedURL =
      "https://#{ location.host }/calendar/" +
      "#{ Auth.me().id }/#{ @model.id }/#{ key }.ics"

    if !key
      @generating = true
      @model.generateCalendarKey()

    @$el.html(template({
      isEnabled: prefs.calendarFeedEnabled
      isGenerated: key? && !@generating
      url: feedURL
      canChange: @model.editable()
    }))

    @

  focusInput: (e) ->
    @$('.js-calendar-feed-url').focus().select()

  selectFeedEnabled: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('a')
    setting = $target.attr('name') == 'enabled'
    @model.setPref('calendarFeedEnabled', setting)



// WEBPACK FOOTER //
// ./app/scripts/views/power-ups/calendar-settings-view.coffee